import { combineReducers, compose } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import authReducer, { authStateType } from "./reducers/auth.reducer";
import uiReducer, { uiStateType } from "./reducers/ui.reducer";
import peopleReducer, { peopleStateType } from "./reducers/people.reducer";
import alertReducer, { alertStateType } from "./reducers/alert.reducer";
import companyReducer, { companyStateType } from "./reducers/company.reducer";
import customfieldReducer, {
  customFieldStateType,
} from "./reducers/customfield.reducer";
import profileReducer, { profileStateType } from "./reducers/profile.reducer";
import timesheet, { timesheetStateType } from "./reducers/timesheet.reducer";
import settings, { settingsStateType } from "./reducers/settings.reducer";
import companywardReducer, {
  companyWardStateType,
} from "./reducers/companyward.reducer";

import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import scheduleReducer, {
  scheduleStateType,
} from "./reducers/schedule.reducer";
import { Dispatch } from "react";
import dashboardReducer, {
  dashboardStateType,
} from "./reducers/dashboard.reducer";
import worktypeReducer, {
  WorktypeStateType,
} from "./reducers/worktype.reducer";

const preloadedState = {};
const middleware = [thunk];

export type actionType = {
  type: string;
  payload: any;
  message?: string;
};

export type ThunkDispatchType = Dispatch<any>;

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION__?: typeof compose;
  }
}

export type storeStateType = {
  dashboard: dashboardStateType;
  auth: authStateType;
  UI: uiStateType;
  people: peopleStateType;
  alert: alertStateType;
  company: companyStateType;
  customfield: customFieldStateType;
  profile: profileStateType;
  employeetimesheet: timesheetStateType;
  sitesetting: settingsStateType;
  companyward: companyWardStateType;
  worktype: WorktypeStateType;
  schedule: scheduleStateType;

  // schedule: scheduleStateType;
  // worktype: WorktypeStateType;
  // dashboard: dashboardStateType;
};

const reducer = combineReducers({
  dashboard: dashboardReducer,
  auth: authReducer,
  UI: uiReducer,
  people: peopleReducer,
  alert: alertReducer,
  company: companyReducer,
  customfield: customfieldReducer,
  profile: profileReducer,
  employeetimesheet: timesheet,
  sitesetting: settings,
  companyward: companywardReducer,
  worktype: worktypeReducer,
  schedule: scheduleReducer,
});

const store = configureStore({
  reducer,
  preloadedState,
  middleware,
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
